<app-spinner></app-spinner>
<!--Because the nav component loves to throw a fit about the missing .contentBody class, we're kindly informing it that we're on a page that's too cool for navigation.
We may need to revisit this hack after updating the alaska-navigation package-->
<div class="contentBody" style="display: none" tabindex="-1"></div>
<router-outlet></router-outlet>
